import type { VocabularyEntry } from '@/db/Types'
import type { PlayCallChip } from '@/types/BlockProperties'
import { UnifiedSearchBar } from '../search/UnifiedSearchBar'
import { Button } from '@/components/ui/Button'
import './play-header.css'

interface PlayHeaderProps {
	teamId: string | null
	playbookId?: string
	initialChips?: PlayCallChip[]
	onChipsChange?: (chips: PlayCallChip[]) => void
	onBackToPlaybook?: () => void
	onVocabularySelect: (entry: VocabularyEntry) => void
	onPlaySelect: (playId: string) => void
	onCreatePlay?: (chips: PlayCallChip[], name: string) => void
}

export function PlayHeader({
	teamId,
	playbookId,
	initialChips,
	onChipsChange,
	onBackToPlaybook,
	onVocabularySelect,
	onPlaySelect,
	onCreatePlay,
}: PlayHeaderProps) {
	return (
		<div className="play-header">
			<div className="play-header__content">
				<div className="play-header__search">
					<UnifiedSearchBar
						teamId={teamId}
						playbookId={playbookId}
						placeholder="Type play call or search..."
						initialChips={initialChips}
						onChipsChange={onChipsChange}
						onVocabularySelect={onVocabularySelect}
						onPlaySelect={onPlaySelect}
						onCreatePlay={onCreatePlay}
					/>
				</div>
				{onBackToPlaybook && (
					<div className="play-header__button-area">
						<Button variant="action" className="play-header__button" onClick={onBackToPlaybook}>
							Back to Playbook
						</Button>
					</div>
				)}
			</div>
		</div>
	)
}
